"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateVoucherApplicationContextSchema = exports.CreateVoucherApplicationSchema = exports.VoucherApplicationSchema = exports.InterestFrom = exports.VoucherApplicationType = exports.VoucherApplicationTarget = void 0;
const Joi = __importStar(require("joi"));
const vouchers_1 = require("../economy/vouchers");
var VoucherApplicationTarget;
(function (VoucherApplicationTarget) {
    VoucherApplicationTarget["Company"] = "COMPANY";
    VoucherApplicationTarget["Person"] = "PERSON";
    VoucherApplicationTarget["Both"] = "BOTH";
})(VoucherApplicationTarget || (exports.VoucherApplicationTarget = VoucherApplicationTarget = {}));
var VoucherApplicationType;
(function (VoucherApplicationType) {
    VoucherApplicationType["VoucherType"] = "VOUCHER_TYPE";
    VoucherApplicationType["VoucherCategory"] = "VOUCHER_CATEGORY";
    VoucherApplicationType["Case"] = "CASE";
})(VoucherApplicationType || (exports.VoucherApplicationType = VoucherApplicationType = {}));
var InterestFrom;
(function (InterestFrom) {
    InterestFrom["Date"] = "DATE";
    InterestFrom["DueDate"] = "DUE_DATE";
})(InterestFrom || (exports.InterestFrom = InterestFrom = {}));
const InterestOptionsSchema = Joi.object({
    days: Joi.number().required(),
    from: Joi.string()
        .valid(...Object.values(InterestFrom))
        .required(),
    fromDateProperty: Joi.string(),
});
exports.VoucherApplicationSchema = Joi.object({
    type: Joi.string()
        .valid(...Object.values(VoucherApplicationType))
        .required(),
    voucherType: Joi.string()
        .valid(...Object.values(vouchers_1.VoucherTypeIds))
        .required(),
    target: Joi.string()
        .valid(...Object.values(VoucherApplicationTarget))
        .required(),
    applyToVoucherType: Joi.string()
        .valid(...Object.values(vouchers_1.VoucherTypeIds))
        .when('type', {
        is: VoucherApplicationType.VoucherType,
        then: Joi.required(),
        otherwise: Joi.forbidden(),
    }),
    applyToVoucherCategory: Joi.string()
        .valid(...Object.values(vouchers_1.VoucherCategory))
        .when('type', {
        is: VoucherApplicationType.VoucherCategory,
        then: Joi.required(),
        otherwise: Joi.forbidden(),
    }),
    voucherOptions: Joi.when('voucherType', {
        is: vouchers_1.VoucherTypeIds.PROCESSINTEREST,
        then: InterestOptionsSchema.required(),
        otherwise: Joi.when('voucherType', {
            is: Joi.valid(vouchers_1.VoucherTypeIds.GLPROCESSINTEREST),
            then: InterestOptionsSchema.required(),
            otherwise: Joi.when('voucherType', {
                is: Joi.valid(vouchers_1.VoucherTypeIds.YEARLYINTEREST),
                then: InterestOptionsSchema.append({
                    interestRate: Joi.number().required(),
                }),
                otherwise: Joi.when('voucherType', {
                    is: Joi.valid(vouchers_1.VoucherTypeIds.FIXEDINTEREST),
                    then: InterestOptionsSchema.append({
                        amount: Joi.number().required(),
                    }),
                    otherwise: Joi.object({
                        amount: Joi.number().required(),
                    }).required(),
                }),
            }),
        }),
    }),
});
exports.CreateVoucherApplicationSchema = Joi.object({
    application: exports.VoucherApplicationSchema.required(),
    creditorId: Joi.string().uuid(),
});
exports.UpdateVoucherApplicationContextSchema = Joi.object({
    enabled: Joi.boolean(),
});
//# sourceMappingURL=index.js.map